import { render, staticRenderFns } from "./ModuleItem.vue?vue&type=template&id=cef6f608&scoped=true&"
import script from "./ModuleItem.vue?vue&type=script&lang=js&"
export * from "./ModuleItem.vue?vue&type=script&lang=js&"
import style0 from "./ModuleItem.vue?vue&type=style&index=0&id=cef6f608&prod&lang=scss&scoped=true&"
import style1 from "./ModuleItem.vue?vue&type=style&index=1&id=cef6f608&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef6f608",
  null
  
)

export default component.exports